import { motion } from 'framer-motion';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
export default function Step1({
  formData,
  setFormData,
  errors,
  handleChange,
  nextStep,
  cancel,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="h-[400px] overflow-y-auto"
    >
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-2xl font-bold text-gray-900 mb-2"
      >
        Your Legal Profile
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-sm font-semibold text-gray-600 mb-6"
      >
        Tell us who you are — personalize your experience.
      </motion.p>

      <motion.form
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="space-y-4"
      >
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Enter your Full Name<span className="text-red-500">*</span>
          </label>
          <input
            name="fullName"
            type="text"
            value={formData.fullName}
            onChange={(e) => handleChange('fullName', e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Enter your Phone Number{' '}
            <span className="text-gray-400">(optional)</span>
          </label>
          <PhoneInput
            country={'us'}
            value={formData.phoneNumber}
            onChange={(value) => handleChange('phoneNumber', value)}
            containerClass="w-full"
            inputClass="!w-full !text-sm !py-3 !pl-[52px] !border !border-gray-300 !rounded-md !bg-white !text-gray-900 focus:!ring-2 focus:!ring-indigo-500 focus:!outline-none"
            buttonClass="!bg-gray-100 !border-gray-300 !border-r"
          />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="flex justify-end gap-3 mt-6"
        >
          <motion.button
            type="button"
            onClick={nextStep}
            className="px-14 py-2 bg-gradient-to-r from-brandDark to-brand text-white rounded hover:brightness-110 transition"
          >
            Next
          </motion.button>
        </motion.div>
      </motion.form>
    </motion.div>
  );
}
